"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _bs = require("react-icons/bs");

var _constants = require("./constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-back-to-top-container {\n  position: absolute;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 3.5rem;\n  width: 3.5rem;\n  border-radius: 50%;\n  background-color: #0561a7; }\n  .bds-back-to-top-container:hover {\n    background-color: #007fe0; }\n\n.bds-back-to-top-arrow {\n  color: white;\n  display: flex; }\n\n[id^='bds-back-to-top-modal'] {\n  position: absolute;\n  width: fit-content;\n  height: fit-content;\n  min-height: 0;\n  z-index: 29; }\n";
  var fileName = "compone_backToTop";
  var element = document.querySelector("style[data-sass-component='compone_backToTop']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var BackToTop = function BackToTop(_ref) {
  var parentRef = _ref.parentRef,
      id = _ref.id;

  var _useState = (0, _react.useState)(document.createElement('div')),
      _useState2 = _slicedToArray(_useState, 1),
      portalModal = _useState2[0];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      show = _useState4[0],
      setShow = _useState4[1];

  portalModal.id = "".concat(_constants.portalId, "-").concat(id);
  portalModal.style.top = 0;
  portalModal.style.left = 0;
  (0, _react.useLayoutEffect)(function () {
    parentRef.current && onResize();
  }, [parentRef.current]);

  var handleOnScroll = function handleOnScroll() {
    if (parentRef.current.scrollTop >= parentRef.current.offsetHeight / 2) setShow(true);else if (parentRef.current.scrollTop <= parentRef.current.offsetHeight / 2) setShow(false);
  };

  var onResize = function onResize() {
    if (parentRef.current) {
      var _parentRef$current$ge = parentRef.current.getBoundingClientRect(),
          bottom = _parentRef$current$ge.bottom,
          right = _parentRef$current$ge.right;

      parentRef.current.onscroll = function () {
        return handleOnScroll();
      };

      portalModal.style.transform = "translate(".concat(right - _constants.width - _constants.rightOffset - (parentRef.current.offsetWidth - parentRef.current.clientWidth), "px,").concat(bottom - _constants.bottomOffset - _constants.width, "px)");
    }
  };

  (0, _react.useEffect)(function () {
    document.body.appendChild(portalModal);
    return function () {
      return document.body.removeChild(portalModal);
    };
  }, []);
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', onResize);
    return function () {
      return window.removeEventListener('resize', onResize);
    };
  }, []);

  var handleClick = function handleClick() {
    parentRef.current.scrollTo(0, 0);
  };

  return show && /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.container,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.arrow
  }, /*#__PURE__*/_react.default.createElement(_bs.BsArrowUpShort, {
    size: _constants.arrowSize
  }))), portalModal);
};

BackToTop.propTypes = {
  parentRef: _propTypes.default.any
};
var _default = BackToTop;
exports.default = _default;